import { lazy as reactLazy } from 'react';
var DynamicCustomProductRequestForm$63 = reactLazy(function () {
  return import('/pwa.build/src/pages/CustomProductRequestForm/customProductRequestForm.js');
});
var DynamicOldWebsiteCollectionRedirect$62 = reactLazy(function () {
  return import('/pwa.build/src/components/Redirect/collectionRedirect.js');
});
var DynamicOldWebsiteProductRedirect$61 = reactLazy(function () {
  return import('/pwa.build/src/components/Redirect/productRedirect.js');
});
var DynamicPOTracker$60 = reactLazy(function () {
  return import('/pwa.build/src/pages/PoTracker/poTracker.js');
});
var DynamicContactConfirmation$59 = reactLazy(function () {
  return import('/pwa.build/src/pages/Contact/ContactConfirmation/contactConfirmation.js');
});
var DynamicTradeDirectAccountConfirmation$58 = reactLazy(function () {
  return import('/pwa.build/src/pages/TradeDirectAccountConfirmation/tradeDirectAccountConfirmation.js');
});
var DynamicProductRegistrationConfirmation$57 = reactLazy(function () {
  return import('/pwa.build/src/pages/ProductRegistrationConfirmation/productRegistrationConfirmation.js');
});
var DynamicTradeprogramapplication$56 = reactLazy(function () {
  return import('/pwa.build/src/pages/TradeProgramAppForm/index.js');
});
var DynamicSubmitaclaim$55 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/SubmitClaim/index.js');
});
var DynamicCompanyStructure$54 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/CompanyStructure/companyStructure.js');
});
var DynamicFavorites$53 = reactLazy(function () {
  return import('/pwa.build/src/overrides/venia-ui/components/WishlistPage/index.js');
});
var DynamicQuotesRequest$52 = reactLazy(function () {
  return import('/pwa.build/src/pages/Quote/quoteRequest.js');
});
var DynamicQuickOrder$51 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/QuickOrder/index.js');
});
var DynamicCommercialGalleryInstallations$50 = reactLazy(function () {
  return import('/pwa.build/src/pages/CommercialInstallationsGallery/index.js');
});
var DynamicResidentialGalleryInstallations$49 = reactLazy(function () {
  return import('/pwa.build/src/pages/ResidentialInstallationsGallery/index.js');
});
var DynamicRolesandPermissions$48 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/RolesPermissions/rolesPermissions.js');
});
var DynamicCompanyUsers$47 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/CompanyUsers/companyUsers.js');
});
var DynamicFrequentlyOrdered$46 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/FrequentlyOrderProducts/index.js');
});
var DynamicNewsletterSubscriptions$45 = reactLazy(function () {
  return import('/pwa.build/src/overrides/venia-ui/components/CommunicationsPage/index.js');
});
var DynamicLifetimeLimitedWarranty$44 = reactLazy(function () {
  return import('/pwa.build/src/pages/WarrantyPage/warrantyPage.js');
});
var DynamicCollections$43 = reactLazy(function () {
  return import('/pwa.build/src/pages/Collections/collections.js');
});
var DynamicCollectionLanding$42 = reactLazy(function () {
  return import('/pwa.build/src/pages/Collections/collectionLanding.js');
});
var DynamicOrderconfirmation$41 = reactLazy(function () {
  return import('/pwa.build/src/pages/OrderConfirmation/orderConfirmation.js');
});
var DynamicResetpassword$40 = reactLazy(function () {
  return import('/pwa.build/src/pages/ResetPassword/resetPassword.js');
});
var DynamicResources$39 = reactLazy(function () {
  return import('/pwa.build/src/pages/Resources/resources.js');
});
var DynamiccompanyProfile$38 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/CompanyProfile/index.js');
});
var DynamicmyInvoices$37 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/MyInvoices/myInvoices.js');
});
var DynamicMyOrders$36 = reactLazy(function () {
  return import('/pwa.build/src/overrides/venia-ui/components/OrderHistoryPage/index.js');
});
var DynamicAddressBook$35 = reactLazy(function () {
  return import('/pwa.build/src/overrides/venia-ui/components/AddressBookPage/index.js');
});
var DynamicUserInformation$34 = reactLazy(function () {
  return import('/pwa.build/src/overrides/venia-ui/components/AccountInformationPage/index.js');
});
var DynamicAccountpage$33 = reactLazy(function () {
  return import('/pwa.build/src/pages/Account/accountPage.js');
});
var DynamicConfirmationpage$32 = reactLazy(function () {
  return import('/pwa.build/src/components/Confirmation/confirmationPage.js');
});
var DynamicSampleRequest$31 = reactLazy(function () {
  return import('/pwa.build/src/pages/SampleRequest/sampleRequest.js');
});
var DynamicDealers$30 = reactLazy(function () {
  return import('/pwa.build/src/pages/Dealers/dealers.js');
});
var DynamicContactPage$29 = reactLazy(function () {
  return import('/pwa.build/src/pages/Contact/contactPage.js');
});
var DynamicPartnerships$28 = reactLazy(function () {
  return import('/pwa.build/src/pages/Partnerships/partnerships.js');
});
var DynamicPartnershipsHome$27 = reactLazy(function () {
  return import('/pwa.build/src/pages/Partnerships/homePartnerships.js');
});
var DynamicFindARepPage$26 = reactLazy(function () {
  return import('/pwa.build/src/pages/FindARep/findARepPage.js');
});
var DynamicVideoGallery$25 = reactLazy(function () {
  return import('/pwa.build/src/pages/VideoGallery/videoGallery.js');
});
var DynamicDesignTeam$24 = reactLazy(function () {
  return import('/pwa.build/src/pages/DesignTeam/designTeam.js');
});
var DynamicAboutCareers$23 = reactLazy(function () {
  return import('/pwa.build/src/pages/Careers/careers.js');
});
var DynamicFrequentlyAskedQuestions$22 = reactLazy(function () {
  return import('/pwa.build/src/pages/Faq/frequentlyAskedQuestions.js');
});
var DynamicCompanyandourteam$21 = reactLazy(function () {
  return import('/pwa.build/src/pages/CompanyTeam/companyOurTeam.js');
});
var DynamicSignInPage$20 = reactLazy(function () {
  return import('/pwa.build/src/components/SignInPage/signInPage.js');
});
var DynamicCustomcapabilities$19 = reactLazy(function () {
  return import('/pwa.build/src/pages/CustomCapabilities/CustomCapabilities.js');
});
var DynamicRegisterPageTypeTwo$18 = reactLazy(function () {
  return import('/pwa.build/src/pages/Register/professionalsRegister.js');
});
var DynamicFinishandColorSwatches$17 = reactLazy(function () {
  return import('/pwa.build/src/pages/FinishColorSwatches/index.js');
});
var DynamicRegisterPageTypeOne$16 = reactLazy(function () {
  return import('/pwa.build/src/pages/Register/CustomerRegistration/customerRegistration.js');
});
var DynamicRegisterPage$15 = reactLazy(function () {
  return import('/pwa.build/src/pages/Register/registerPage.js');
});
var DynamicWishlistPage$14 = reactLazy(function () {
  return import('../WishlistPage');
});
var DynamicSignInPage$13 = reactLazy(function () {
  return import('../SignInPage');
});
var DynamicSearch$12 = reactLazy(function () {
  return import('../../RootComponents/Search');
});
var DynamicSavedPayments$11 = reactLazy(function () {
  return import('../SavedPaymentsPage');
});
var DynamicResetPassword$10 = reactLazy(function () {
  return import('../MyAccount/ResetPassword');
});
var DynamicOrderHistory$9 = reactLazy(function () {
  return import('../OrderHistoryPage');
});
var DynamicForgotPasswordPage$8 = reactLazy(function () {
  return import('../ForgotPasswordPage');
});
var DynamicCreateAccountPage$7 = reactLazy(function () {
  return import('../CreateAccountPage');
});
var DynamicContactPage$6 = reactLazy(function () {
  return import('../ContactPage');
});
var DynamicCommunicationsPage$5 = reactLazy(function () {
  return import('../CommunicationsPage');
});
var DynamicCheckoutPage$4 = reactLazy(function () {
  return import('../CheckoutPage');
});
var DynamicCart$3 = reactLazy(function () {
  return import('../CartPage');
});
var DynamicAddressBook$2 = reactLazy(function () {
  return import('../AddressBookPage');
});
var DynamicAccountInformationPage$1 = reactLazy(function () {
  return import('../AccountInformationPage');
});
import AuthRoute from "./authRoute";
import React, { Suspense } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useScrollTopOnChange } from '@magento/peregrine/lib/hooks/useScrollTopOnChange';
import { fullPageLoadingIndicator } from '../LoadingIndicator';
import HomePage from '../HomePage';
import MagentoRoute from '../MagentoRoute';

var Routes = function Routes() {
  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  useScrollTopOnChange(pathname);
  return React.createElement(Suspense, {
    fallback: fullPageLoadingIndicator
  }, React.createElement(Switch, null, React.createElement(Route, {
    path: "/custom-product-request-form"
  }, React.createElement(DynamicCustomProductRequestForm$63, null)), React.createElement(Route, {
    path: "/filter/"
  }, React.createElement(DynamicOldWebsiteCollectionRedirect$62, null)), React.createElement(Route, {
    path: "/old-products/:baseItemSku/:skuLevelItemSku"
  }, React.createElement(DynamicOldWebsiteProductRedirect$61, null)), React.createElement(Route, {
    path: "/old-products/:baseItemSku"
  }, React.createElement(DynamicOldWebsiteProductRedirect$61, null)), React.createElement(Route, {
    path: "/po-tracker"
  }, React.createElement(DynamicPOTracker$60, null)), React.createElement(Route, {
    path: "/contact-confirmation"
  }, React.createElement(DynamicContactConfirmation$59, null)), React.createElement(Route, {
    path: "/trade-direct-account-confirmation"
  }, React.createElement(DynamicTradeDirectAccountConfirmation$58, null)), React.createElement(Route, {
    path: "/successful-product-registration"
  }, React.createElement(DynamicProductRegistrationConfirmation$57, null)), React.createElement(Route, {
    path: "/trade-program-application"
  }, React.createElement(DynamicTradeprogramapplication$56, null)), React.createElement(Route, {
    path: "/my-account/submit-claim"
  }, React.createElement(DynamicSubmitaclaim$55, null)), React.createElement(Route, {
    path: "/my-account/company-structure"
  }, React.createElement(DynamicCompanyStructure$54, null)), React.createElement(Route, {
    path: "/favorites"
  }, React.createElement(DynamicFavorites$53, null)), React.createElement(Route, {
    path: "/quote-request"
  }, React.createElement(DynamicQuotesRequest$52, null)), React.createElement(Route, {
    path: "/my-account/quick-order"
  }, React.createElement(DynamicQuickOrder$51, null)), React.createElement(Route, {
    path: "/inspiration/installations-commercial-gallery"
  }, React.createElement(DynamicCommercialGalleryInstallations$50, null)), React.createElement(Route, {
    path: "/inspiration/installations-residential-gallery"
  }, React.createElement(DynamicResidentialGalleryInstallations$49, null)), React.createElement(Route, {
    path: "/my-account/roles-and-permissions"
  }, React.createElement(DynamicRolesandPermissions$48, null)), React.createElement(Route, {
    path: "/my-account/company-users"
  }, React.createElement(DynamicCompanyUsers$47, null)), React.createElement(Route, {
    path: "/my-account/frequently-ordered"
  }, React.createElement(DynamicFrequentlyOrdered$46, null)), React.createElement(Route, {
    path: "/my-account/newsletter-subscription"
  }, React.createElement(DynamicNewsletterSubscriptions$45, null)), React.createElement(Route, {
    path: "/about/lifetime-limited-warranty"
  }, React.createElement(DynamicLifetimeLimitedWarranty$44, null)), React.createElement(Route, {
    path: "/collections"
  }, React.createElement(DynamicCollections$43, null)), React.createElement(Route, {
    path: "/collection-landing/:collectionsSlug"
  }, React.createElement(DynamicCollectionLanding$42, null)), React.createElement(Route, {
    path: "/order-confirmation"
  }, React.createElement(DynamicOrderconfirmation$41, null)), React.createElement(Route, {
    path: "/reset-password"
  }, React.createElement(DynamicResetpassword$40, null)), React.createElement(Route, {
    path: "/resources"
  }, React.createElement(DynamicResources$39, null)), React.createElement(Route, {
    path: "/my-account/company-profile"
  }, React.createElement(DynamiccompanyProfile$38, null)), React.createElement(Route, {
    path: "/my-account/my-invoices"
  }, React.createElement(DynamicmyInvoices$37, null)), React.createElement(Route, {
    path: "/my-account/order-history"
  }, React.createElement(DynamicMyOrders$36, null)), React.createElement(Route, {
    path: "/my-account/address-book"
  }, React.createElement(DynamicAddressBook$35, null)), React.createElement(Route, {
    path: "/my-account/user-information"
  }, React.createElement(DynamicUserInformation$34, null)), React.createElement(Route, {
    path: "/my-account"
  }, React.createElement(DynamicAccountpage$33, null)), React.createElement(Route, {
    path: "/confirmation/:type"
  }, React.createElement(DynamicConfirmationpage$32, null)), React.createElement(Route, {
    path: "/inspiration/finish-color-swatches/sample-request"
  }, React.createElement(DynamicSampleRequest$31, null)), React.createElement(Route, {
    path: "/where-to-buy/:whereToBuySlug"
  }, React.createElement(DynamicDealers$30, null)), React.createElement(Route, {
    path: "/about/contact"
  }, React.createElement(DynamicContactPage$29, null)), React.createElement(Route, {
    path: "/about/partnerships/:partnershipSlug"
  }, React.createElement(DynamicPartnerships$28, null)), React.createElement(Route, {
    path: "/about/partnerships"
  }, React.createElement(DynamicPartnershipsHome$27, null)), React.createElement(Route, {
    path: "/find-a-rep/:type"
  }, React.createElement(DynamicFindARepPage$26, null)), React.createElement(Route, {
    path: "/inspiration/video-gallery"
  }, React.createElement(DynamicVideoGallery$25, null)), React.createElement(Route, {
    path: "/about/designers"
  }, React.createElement(DynamicDesignTeam$24, null)), React.createElement(Route, {
    path: "/about/careers"
  }, React.createElement(DynamicAboutCareers$23, null)), React.createElement(Route, {
    path: "/about/faq"
  }, React.createElement(DynamicFrequentlyAskedQuestions$22, null)), React.createElement(Route, {
    path: "/about/company-our-team"
  }, React.createElement(DynamicCompanyandourteam$21, null)), React.createElement(Route, {
    path: "/sign-in"
  }, React.createElement(DynamicSignInPage$20, null)), React.createElement(Route, {
    path: "/for-professionals/custom-capabilities"
  }, React.createElement(DynamicCustomcapabilities$19, null)), React.createElement(Route, {
    path: "/register/:type"
  }, React.createElement(DynamicRegisterPageTypeTwo$18, null)), React.createElement(Route, {
    path: "/about/finish-color-swatches"
  }, React.createElement(DynamicFinishandColorSwatches$17, null)), React.createElement(Route, {
    path: "/consumer/register"
  }, React.createElement(DynamicRegisterPageTypeOne$16, null)), React.createElement(Route, {
    path: "/register"
  }, React.createElement(DynamicRegisterPage$15, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/wishlist"
  }, React.createElement(DynamicWishlistPage$14, null)), React.createElement(Route, {
    exact: true,
    path: "/sign-in"
  }, React.createElement(DynamicSignInPage$13, null)), React.createElement(Route, {
    exact: true,
    path: "/search.html"
  }, React.createElement(DynamicSearch$12, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/saved-payments"
  }, React.createElement(DynamicSavedPayments$11, null)), React.createElement(Route, {
    exact: true,
    path: "/customer/account/createPassword"
  }, React.createElement(DynamicResetPassword$10, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/order-history"
  }, React.createElement(DynamicOrderHistory$9, null)), React.createElement(Route, {
    exact: true,
    path: "/forgot-password"
  }, React.createElement(DynamicForgotPasswordPage$8, null)), React.createElement(Route, {
    exact: true,
    path: "/create-account"
  }, React.createElement(DynamicCreateAccountPage$7, null)), React.createElement(Route, {
    exact: true,
    path: "/contact-us"
  }, React.createElement(DynamicContactPage$6, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/communications"
  }, React.createElement(DynamicCommunicationsPage$5, null)), React.createElement(Route, {
    exact: true,
    path: "/checkout"
  }, React.createElement(DynamicCheckoutPage$4, null)), React.createElement(Route, {
    exact: true,
    path: "/cart"
  }, React.createElement(DynamicCart$3, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/address-book"
  }, React.createElement(DynamicAddressBook$2, null)), React.createElement(AuthRoute, {
    exact: true,
    redirectTo: "/sign-in",
    path: "/account-information"
  }, React.createElement(DynamicAccountInformationPage$1, null)), React.createElement(Route, null, React.createElement(MagentoRoute, null), React.createElement(Route, {
    exact: true,
    path: "/"
  }, React.createElement(HomePage, null)))));
};

export default Routes;
var availableRoutes = [];
availableRoutes.push({
  "name": "Custom Product Request Form",
  "pattern": "/custom-product-request-form",
  "path": "/pwa.build/src/pages/CustomProductRequestForm/customProductRequestForm.js"
});
availableRoutes.push({
  "name": "Old Website Collection Redirect",
  "pattern": "/filter/",
  "path": "/pwa.build/src/components/Redirect/collectionRedirect.js"
});
availableRoutes.push({
  "name": "Old Website Product Redirect",
  "pattern": "/old-products/:baseItemSku/:skuLevelItemSku",
  "path": "/pwa.build/src/components/Redirect/productRedirect.js"
});
availableRoutes.push({
  "name": "Old Website Product Redirect",
  "pattern": "/old-products/:baseItemSku",
  "path": "/pwa.build/src/components/Redirect/productRedirect.js"
});
availableRoutes.push({
  "name": "PO Tracker",
  "pattern": "/po-tracker",
  "path": "/pwa.build/src/pages/PoTracker/poTracker.js"
});
availableRoutes.push({
  "name": "Contact Confirmation",
  "pattern": "/contact-confirmation",
  "path": "/pwa.build/src/pages/Contact/ContactConfirmation/contactConfirmation.js"
});
availableRoutes.push({
  "name": "Trade Direct Account Confirmation",
  "pattern": "/trade-direct-account-confirmation",
  "path": "/pwa.build/src/pages/TradeDirectAccountConfirmation/tradeDirectAccountConfirmation.js"
});
availableRoutes.push({
  "name": "Product Registration Confirmation",
  "pattern": "/successful-product-registration",
  "path": "/pwa.build/src/pages/ProductRegistrationConfirmation/productRegistrationConfirmation.js"
});
availableRoutes.push({
  "name": "Trade program application",
  "pattern": "/trade-program-application",
  "path": "/pwa.build/src/pages/TradeProgramAppForm/index.js"
});
availableRoutes.push({
  "name": "Submit a claim",
  "pattern": "/my-account/submit-claim",
  "path": "/pwa.build/src/pages/Account/SubmitClaim/index.js"
});
availableRoutes.push({
  "name": "Company Structure",
  "pattern": "/my-account/company-structure",
  "path": "/pwa.build/src/pages/Account/CompanyStructure/companyStructure.js"
});
availableRoutes.push({
  "name": "Favorites",
  "pattern": "/favorites",
  "path": "/pwa.build/src/overrides/venia-ui/components/WishlistPage/index.js"
});
availableRoutes.push({
  "name": "Quotes Request",
  "pattern": "/quote-request",
  "path": "/pwa.build/src/pages/Quote/quoteRequest.js"
});
availableRoutes.push({
  "name": "Quick Order",
  "pattern": "/my-account/quick-order",
  "path": "/pwa.build/src/pages/Account/QuickOrder/index.js"
});
availableRoutes.push({
  "name": "Commercial Gallery Installations",
  "pattern": "/inspiration/installations-commercial-gallery",
  "path": "/pwa.build/src/pages/CommercialInstallationsGallery/index.js"
});
availableRoutes.push({
  "name": "Residential Gallery Installations",
  "pattern": "/inspiration/installations-residential-gallery",
  "path": "/pwa.build/src/pages/ResidentialInstallationsGallery/index.js"
});
availableRoutes.push({
  "name": "Roles and Permissions",
  "pattern": "/my-account/roles-and-permissions",
  "path": "/pwa.build/src/pages/Account/RolesPermissions/rolesPermissions.js"
});
availableRoutes.push({
  "name": "Company Users",
  "pattern": "/my-account/company-users",
  "path": "/pwa.build/src/pages/Account/CompanyUsers/companyUsers.js"
});
availableRoutes.push({
  "name": "Frequently Ordered",
  "pattern": "/my-account/frequently-ordered",
  "path": "/pwa.build/src/pages/Account/FrequentlyOrderProducts/index.js"
});
availableRoutes.push({
  "name": "Newsletter Subscriptions",
  "pattern": "/my-account/newsletter-subscription",
  "path": "/pwa.build/src/overrides/venia-ui/components/CommunicationsPage/index.js"
});
availableRoutes.push({
  "name": "Lifetime Limited Warranty",
  "pattern": "/about/lifetime-limited-warranty",
  "path": "/pwa.build/src/pages/WarrantyPage/warrantyPage.js"
});
availableRoutes.push({
  "name": "Collections",
  "pattern": "/collections",
  "path": "/pwa.build/src/pages/Collections/collections.js"
});
availableRoutes.push({
  "name": "Collection Landing",
  "pattern": "/collection-landing/:collectionsSlug",
  "path": "/pwa.build/src/pages/Collections/collectionLanding.js"
});
availableRoutes.push({
  "name": "Order confirmation",
  "pattern": "/order-confirmation",
  "path": "/pwa.build/src/pages/OrderConfirmation/orderConfirmation.js"
});
availableRoutes.push({
  "name": "Reset password",
  "pattern": "/reset-password",
  "path": "/pwa.build/src/pages/ResetPassword/resetPassword.js"
});
availableRoutes.push({
  "name": "Resources",
  "pattern": "/resources",
  "path": "/pwa.build/src/pages/Resources/resources.js"
});
availableRoutes.push({
  "name": "company Profile",
  "pattern": "/my-account/company-profile",
  "path": "/pwa.build/src/pages/Account/CompanyProfile/index.js"
});
availableRoutes.push({
  "name": "my Invoices",
  "pattern": "/my-account/my-invoices",
  "path": "/pwa.build/src/pages/Account/MyInvoices/myInvoices.js"
});
availableRoutes.push({
  "name": "My Orders",
  "pattern": "/my-account/order-history",
  "path": "/pwa.build/src/overrides/venia-ui/components/OrderHistoryPage/index.js"
});
availableRoutes.push({
  "name": "Address Book",
  "pattern": "/my-account/address-book",
  "path": "/pwa.build/src/overrides/venia-ui/components/AddressBookPage/index.js"
});
availableRoutes.push({
  "name": "User Information",
  "pattern": "/my-account/user-information",
  "path": "/pwa.build/src/overrides/venia-ui/components/AccountInformationPage/index.js"
});
availableRoutes.push({
  "name": "Account page",
  "pattern": "/my-account",
  "path": "/pwa.build/src/pages/Account/accountPage.js"
});
availableRoutes.push({
  "name": "Confirmation page",
  "pattern": "/confirmation/:type",
  "path": "/pwa.build/src/components/Confirmation/confirmationPage.js"
});
availableRoutes.push({
  "name": "Sample Request",
  "pattern": "/inspiration/finish-color-swatches/sample-request",
  "path": "/pwa.build/src/pages/SampleRequest/sampleRequest.js"
});
availableRoutes.push({
  "name": "Dealers",
  "pattern": "/where-to-buy/:whereToBuySlug",
  "path": "/pwa.build/src/pages/Dealers/dealers.js"
});
availableRoutes.push({
  "name": "Contact Page",
  "pattern": "/about/contact",
  "path": "/pwa.build/src/pages/Contact/contactPage.js"
});
availableRoutes.push({
  "name": "Partnerships",
  "pattern": "/about/partnerships/:partnershipSlug",
  "path": "/pwa.build/src/pages/Partnerships/partnerships.js"
});
availableRoutes.push({
  "name": "Partnerships Home",
  "pattern": "/about/partnerships",
  "path": "/pwa.build/src/pages/Partnerships/homePartnerships.js"
});
availableRoutes.push({
  "name": "Find A Rep Page",
  "pattern": "/find-a-rep/:type",
  "path": "/pwa.build/src/pages/FindARep/findARepPage.js"
});
availableRoutes.push({
  "name": "Video Gallery",
  "pattern": "/inspiration/video-gallery",
  "path": "/pwa.build/src/pages/VideoGallery/videoGallery.js"
});
availableRoutes.push({
  "name": "Design Team",
  "pattern": "/about/designers",
  "path": "/pwa.build/src/pages/DesignTeam/designTeam.js"
});
availableRoutes.push({
  "name": "About Careers",
  "pattern": "/about/careers",
  "path": "/pwa.build/src/pages/Careers/careers.js"
});
availableRoutes.push({
  "name": "Frequently Asked Questions",
  "pattern": "/about/faq",
  "path": "/pwa.build/src/pages/Faq/frequentlyAskedQuestions.js"
});
availableRoutes.push({
  "name": "Company and our team",
  "pattern": "/about/company-our-team",
  "path": "/pwa.build/src/pages/CompanyTeam/companyOurTeam.js"
});
availableRoutes.push({
  "name": "SignInPage",
  "pattern": "/sign-in",
  "path": "/pwa.build/src/components/SignInPage/signInPage.js"
});
availableRoutes.push({
  "name": "Custom capabilities",
  "pattern": "/for-professionals/custom-capabilities",
  "path": "/pwa.build/src/pages/CustomCapabilities/CustomCapabilities.js"
});
availableRoutes.push({
  "name": "Register Page Type Two",
  "pattern": "/register/:type",
  "path": "/pwa.build/src/pages/Register/professionalsRegister.js"
});
availableRoutes.push({
  "name": "Finish and Color Swatches",
  "pattern": "/about/finish-color-swatches",
  "path": "/pwa.build/src/pages/FinishColorSwatches/index.js"
});
availableRoutes.push({
  "name": "Register Page Type One",
  "pattern": "/consumer/register",
  "path": "/pwa.build/src/pages/Register/CustomerRegistration/customerRegistration.js"
});
availableRoutes.push({
  "name": "Register Page",
  "pattern": "/register",
  "path": "/pwa.build/src/pages/Register/registerPage.js"
});
availableRoutes.push({
  "name": "WishlistPage",
  "pattern": "/wishlist",
  "exact": true,
  "path": "../WishlistPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
availableRoutes.push({
  "name": "SignInPage",
  "pattern": "/sign-in",
  "exact": true,
  "path": "../SignInPage"
});
availableRoutes.push({
  "name": "Search",
  "pattern": "/search.html",
  "exact": true,
  "path": "../../RootComponents/Search"
});
availableRoutes.push({
  "name": "SavedPayments",
  "pattern": "/saved-payments",
  "exact": true,
  "path": "../SavedPaymentsPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
availableRoutes.push({
  "name": "Reset Password",
  "pattern": "/customer/account/createPassword",
  "exact": true,
  "path": "../MyAccount/ResetPassword"
});
availableRoutes.push({
  "name": "OrderHistory",
  "pattern": "/order-history",
  "exact": true,
  "path": "../OrderHistoryPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
availableRoutes.push({
  "name": "ForgotPasswordPage",
  "pattern": "/forgot-password",
  "exact": true,
  "path": "../ForgotPasswordPage"
});
availableRoutes.push({
  "name": "CreateAccountPage",
  "pattern": "/create-account",
  "exact": true,
  "path": "../CreateAccountPage"
});
availableRoutes.push({
  "name": "ContactPage",
  "pattern": "/contact-us",
  "exact": true,
  "path": "../ContactPage"
});
availableRoutes.push({
  "name": "CommunicationsPage",
  "pattern": "/communications",
  "exact": true,
  "path": "../CommunicationsPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
availableRoutes.push({
  "name": "CheckoutPage",
  "pattern": "/checkout",
  "exact": true,
  "path": "../CheckoutPage"
});
availableRoutes.push({
  "name": "Cart",
  "pattern": "/cart",
  "exact": true,
  "path": "../CartPage"
});
availableRoutes.push({
  "name": "AddressBook",
  "pattern": "/address-book",
  "exact": true,
  "path": "../AddressBookPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
availableRoutes.push({
  "name": "AccountInformationPage",
  "pattern": "/account-information",
  "exact": true,
  "path": "../AccountInformationPage",
  "authed": true,
  "redirectTo": "/sign-in"
});
export { availableRoutes };